import axios from "axios";
import { Environment } from "../../Config/constants/environment";
import { UserDataStorage } from "../Storage/UserDataStorage";


const api = axios.create({
  baseURL: Environment.apiUrl,
  //  headers: {
  //   "Content-Type": "application/json",
  // },
});

api.interceptors.request.use((config) => {
  const userdata = UserDataStorage.get();
  const jwToken = userdata?.jwToken;
  if (jwToken && config.url && !config.url.includes("/authenticate")) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${jwToken}`;
  }
  return config;
},
(error) => Promise.reject(error)
);
// UserDataStorage.save(data);
api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = UserDataStorage.get().refreshToken;
        //const userData = UserDataStorage.get();
        
        // Make a request to your auth server to refresh the token.
        const responseRefresh = await axios.post(`${Environment.apiUrl}Account/refresh-token`, {
          refreshToken
        });
        const { accessToken} = responseRefresh.data.data;

        UserDataStorage.updateToken(accessToken);
        // console.log("response", responseRefresh);
        
        api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        return api(originalRequest); // Retry the original request with the new access token.
      } catch (refreshError) {
        // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
        console.error('Token refresh failed:', refreshError);

        UserDataStorage.clear();
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;